// extracted by mini-css-extract-plugin
export default {"wrapper":"A_BenefitItem_wrapper__UPl9t","image_wrapper":"A_BenefitItem_image_wrapper__-AGEk","description":"A_BenefitItem_description__7cqz5"};